import { Component, OnInit } from '@angular/core';

import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'signature-callback',
    template: `
        <h2>Signature Complete</h2>
    `,
    imports: [SharedModule]
})
export class SignatureCallbackComponent implements OnInit {
    constructor() {}

    ngOnInit() {
        window.parent.postMessage('signatureComplete', '*');
    }
}
